module.exports = __webpack_public_path__ + "assets/images/ote_sport_5.1b98007824ae2aac66d0a183147f75df.png";